// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {mdiTableArrowUp} from '@mdi/js';
import {Driver} from './interfaces';

type Props = {
  driverDispatch: any;
  data: Driver[];
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.driverDispatch()
  };
  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {
        ...item,
        otpExpiration:
          item.otpExpiration &&
          jMoment(item.otpExpiration, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD'),
      };
    });
    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="drivers.csv"
          style={{
            backgroundColor: '#DFA01F',
            padding: '10px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
          }}
        >
          دانلود CSV
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
